/* Print-specific styles for ResultsPage */

@media print {
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  @page {
    margin: 0.5in;
    size: letter;
    background: white;
  }
  
  /* Hide all non-essential elements */
  nav,
  header,
  footer,
  .navbar,
  .navigation,
  .menu,
  .sidebar,
  .no-print {
    display: none !important;
  }
  
  /* Hide specific navbar and footer elements by common patterns */
  [class*="navbar"],
  [class*="header"],
  [class*="footer"],
  [class*="nav-"],
  [id*="navbar"],
  [id*="header"],
  [id*="footer"] {
    display: none !important;
  }
  
  /* Hide the page wrapper and navigation elements */
  .container:has(.navbar),
  .max-w-6xl > .text-center:first-child {
    display: none !important;
  }
  
  /* Main container adjustments */
  body {
    margin: 0;
    padding: 0;
    background: white !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
    color: black !important;
  }
  
  .container {
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .max-w-6xl {
    max-width: none !important;
    margin: 0 !important;
  }
  
  .pt-32,
  .pt-36,
  .pb-16 {
    padding: 0 !important;
  }
  
  /* Results dashboard styling */
  .bg-white {
    background: white !important;
  }
  
  .shadow-md {
    box-shadow: none !important;
  }
  
  /* Compact the layout */
  .p-6 {
    padding: 12px !important;
  }
  
  .gap-6 {
    gap: 12px !important;
  }
  
  .gap-4 {
    gap: 10px !important;
  }
  
  .mb-6,
  .mb-4 {
    margin-bottom: 8px !important;
  }
  
  .space-y-12 > * + * {
    margin-top: 0 !important;
  }
  
  /* Typography adjustments */
  .text-2xl {
    font-size: 18px !important;
  }
  
  .text-lg {
    font-size: 14px !important;
  }
  
  .text-sm {
    font-size: 11px !important;
  }
  
  .text-xs {
    font-size: 10px !important;
  }
  
  /* Force colors for badges and elements */
  .bg-blue-600,
  .bg-deepBlue {
    background-color: #1B4CB8 !important;
    color: white !important;
  }
  
  .text-blue-600 {
    color: #1B4CB8 !important;
  }
  
  .bg-blue-100 {
    background-color: #DBEAFE !important;
  }
  
  .text-green-600,
  .text-green-500 {
    color: #10B981 !important;
  }
  
  .text-amber-600,
  .text-amber-500 {
    color: #F59E0B !important;
  }
  
  .bg-gray-50 {
    background-color: #F9FAFB !important;
  }
  
  .border-gray-100,
  .border-gray-200 {
    border-color: #E5E7EB !important;
  }
  
  /* Recommendation cards */
  .bg-blue-50 {
    background-color: #EFF6FF !important;
  }
  
  .bg-amber-50 {
    background-color: #FFFBEB !important;
  }
  
  .bg-green-50 {
    background-color: #F0FDF4 !important;
  }
  
  /* Hide interactive elements */
  .clickable-card,
  .card-container {
    cursor: default !important;
  }
  
  /* Ensure proper page breaks */
  .border-b {
    page-break-after: avoid !important;
  }
  
  /* Hide the intro text at top */
  .max-w-2xl {
    display: none !important;
  }
  
  /* Add print header */
  .bg-white.rounded-lg.shadow-md::before {
    content: "Your PMO Maturity Assessment Results";
    display: block;
    font-size: 24px;
    font-weight: bold;
    color: #1B4CB8;
    text-align: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid #1B4CB8;
  }
  
  /* Compact grid layouts */
  .grid-cols-1.md\\:grid-cols-2,
  .grid-cols-1.md\\:grid-cols-3 {
    gap: 10px !important;
  }
}

/* Additional specific print adjustments */
@media print {
  /* Make sure charts and visual elements print well */
  .recharts-wrapper {
    background: white !important;
  }
  
  /* Ensure proper text contrast */
  .text-gray-600,
  .text-gray-700,
  .text-gray-800 {
    color: #374151 !important;
  }
  
  .text-gray-500 {
    color: #6B7280 !important;
  }
}